import React from 'react';
export function MenuRightIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16a1 1 0 01-.7-1.709l2.3-2.286-2.286-2.3A1 1 0 0111.723 8.3l2.991 3a1 1 0 010 1.414L11.7 15.71A1 1 0 0111 16z"
  }));
}